import * as React from 'react';

import * as styles from './LivingConditions.css';
import { EFacilityType, NonEmptyArray } from '../../../../packages/JsonQuery';
import { Checkbox } from '../../../common/components/Checkbox';
import { EFiltersMobileTestId } from '../../types';
import { Filter } from '../Filter';

const LIVING_CONDITIONS = [
  {
    type: EFacilityType.KidsAllowed,
    label: 'Можно с детьми',
    testId: EFiltersMobileTestId.KidsFilterCheckbox,
  },
  {
    type: EFacilityType.PetsAllowed,
    label: 'Можно с животными',
    testId: EFiltersMobileTestId.PetsFilterCheckbox,
  },
];

interface ILivingConditionsProps {
  contentPadding?: boolean;
  value: NonEmptyArray<EFacilityType> | null;
  onChange(condition: EFacilityType, value: boolean): void;
}

export const LivingConditions: React.FC<ILivingConditionsProps> = ({ value, onChange, contentPadding }) => {
  const content = React.useMemo(
    () =>
      LIVING_CONDITIONS.map(({ type, label, testId }) => {
        const isConditionChecked = value?.includes(type) || false;
        const onConditionChange = (event: React.ChangeEvent<HTMLInputElement>) => onChange(type, event.target.checked);

        return (
          <Checkbox
            key={type}
            className={styles['field']}
            label={label}
            value={type}
            checked={isConditionChecked}
            onChange={onConditionChange}
            testId={testId}
          />
        );
      }),
    [value, onChange],
  );

  return (
    <Filter id="filter_living_conditions" className={styles['wrapper']} contentPadding={contentPadding}>
      {content}
    </Filter>
  );
};
